import React, { Component } from 'react'
import Loading from './loading'

export default class Loader extends Component {
    componentDidMount() {
        if (process.env.NODE_ENV === 'test') {
            this.setState({ isVisible: true });
        }
    }

    state = {
        isVisible: false
    }

    show = (isVisible) => {
        this.setState({ isVisible: isVisible });
    }

    render() {
        if (this.state.isVisible) {
            return (
                <Loading />
            )
        }
        else {

            return null;
        }
    }
}
